<template>
  <FormItem :label="label" :prop="$attrs.name">
    <Select
      ref="formInput"
      v-bind="$attrs"
      v-on="$listeners"
      @search="handleInputKeyDown"
      :id="$attrs.name"
    >
      <Option
        v-for="(item, index) in items"
        :key="`${item}-${index}`"
        :value="item[valuePath] || item"
        :disabled="item.disabled"
      >
        {{ item[labelPath] || item }}
      </Option>
    </Select>
  </FormItem>
</template>

<script>
import resourceNamePluralizer from "@/utils/resource-name-pluralizer";
import { Select, FormModel } from "ant-design-vue";
import { mapGetters } from "vuex";

const { Option } = Select;

const STORE_KEY = "searchStore";

export default {
  data() {
    return {
      dropdownItems: [],
      searchKey: ""
    };
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: true
    },
    valuePath: {
      type: String,
      default: "Id"
    },
    labelPath: {
      type: String,
      default: "name"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterByLabel: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Select,
    Option,
    FormItem: FormModel.Item
  },
  computed: {
    ...mapGetters({
      clubs: `${STORE_KEY}/clubs`,
      colleges: `${STORE_KEY}/colleges`,
      states: `${STORE_KEY}/states`,
      collegeGpas: `${STORE_KEY}/collegeGpas`,
      academicSpecialities: `${STORE_KEY}/academicSpecialities`,
      divisions: `${STORE_KEY}/divisions`,
      divisionsLoading: `${STORE_KEY}/divisionsLoading`,
      collegeStates: `${STORE_KEY}/collegeStates`,
      collegeStatesLoading: `${STORE_KEY}/collegeStatesLoading`,
      schoolTypes: `${STORE_KEY}/schoolTypes`,
      schoolTypesLoading: `${STORE_KEY}/schoolTypesLoading`,
      educationTypes: `${STORE_KEY}/educationTypes`,
      educationTypesLoading: `${STORE_KEY}/educationTypesLoading`,
      collegeSettings: `${STORE_KEY}/collegeSettings`,
      collegeSettingsLoading: `${STORE_KEY}/collegeSettingsLoading`,
      ageGroups: `${STORE_KEY}/ageGroups`,
      ageGroupsLoading: `${STORE_KEY}/ageGroupsLoading`,
      playerPositions: `${STORE_KEY}/playerPositions`,
      playerPositionsLoading: `${STORE_KEY}/playerPositionsLoading`,
      playerStates: `${STORE_KEY}/playerStates`,
      playerStatesLoading: `${STORE_KEY}/playerStatesLoading`,
      battingHands: `${STORE_KEY}/battingHands`,
      battingHandsLoading: `${STORE_KEY}/battingHandsLoading`,
      throwingHands: `${STORE_KEY}/throwingHands`,
      throwingHandsLoading: `${STORE_KEY}/throwingHandsLoading`,
      clubEventTypes: `${STORE_KEY}/clubEventTypes`,
      clubEventTypesLoading: `${STORE_KEY}/clubEventTypesLoading`,
      collegeEventTypes: `${STORE_KEY}/collegeEventTypes`,
      collegeEventTypesLoading: `${STORE_KEY}/collegeEventTypesLoading`,
      countries: `${STORE_KEY}/countries`
    }),

    items() {
      return this.dropdownItems.slice(0, 100);
    }
  },
  async mounted() {
    await this.$store.dispatch(`${STORE_KEY}/getTaxonomy`, {
      storeKey: resourceNamePluralizer.get(this.resource),
      loadingKey: `${resourceNamePluralizer.get(this.resource)}Loading`,
      type: this.type
    });
    this.dropdownItems = [...this[resourceNamePluralizer.get(this.resource)]];
    this.dropdownItems = [
      ...this.dropdownItems.filter(
        item => !this.filterByLabel.includes(String(item.name))
      )
    ];
  },
  methods: {
    handleInputKeyDown(event) {
      this.searchKey = event;
    }
  },
  watch: {
    searchKey: {
      immediate: true,
      handler: async function(newVal) {
        this.dropdownItems = [
          ...this[resourceNamePluralizer.get(this.resource)]
        ];
        if (!_.isEmpty(this.filterByLabel)) {
          this.dropdownItems = [
            ...this.dropdownItems.filter(
              item => !this.filterByLabel.includes(String(item.name))
            )
          ];
        }
        if (!newVal) {
          this.dropdownItems = this.dropdownItems.splice(0, 100);
        } else {
          this.dropdownItems = [
            ...this.dropdownItems.filter(item =>
              item.name.toLowerCase().includes(newVal.toLowerCase())
            )
          ];
        }
        this.dropdownItems = this.dropdownItems.splice(0, 100);
      }
    }
  }
};
</script>

<style></style>
